module.exports = __webpack_public_path__ + "static/reduce-employee-churn-47a89b3bab8e03043d903964ca11608c.png";